export enum ButtonTheme {
    LIGHT,
    PRIME,
    TRANSPARENT
}